module.exports = __webpack_public_path__ + "img/search-icon.51dbf250.svg";